import React from "react";
import getConfig from "next/config";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ProductLabels = ({ labels }) => {
  const mesajeTextLabels = [];

  if (labels.text && labels.text["altex_packageproduct/label"]) {
    mesajeTextLabels.push({
      text: labels.text["altex_packageproduct/label"].values,
    });
  }

  if (labels.text && labels.text["altex_vouchercampaigns/label"]) {
    mesajeTextLabels.push(labels.text["altex_vouchercampaigns/label"].values);
  }

  if (
    labels.link &&
    labels.link["altex_label/rule_action_type_cmsPage"] &&
    labels.text &&
    labels.text["altex_label/rule_action_type_text"]
  ) {
    mesajeTextLabels.push({
      text: labels.text["altex_label/rule_action_type_text"].values,
      link: labels.link["altex_label/rule_action_type_cmsPage"].values,
    });
  }

  if (
    !labels.link &&
    labels.text &&
    labels.text["altex_label/rule_action_type_text"]
  ) {
    mesajeTextLabels.push({
      text: labels.text["altex_label/rule_action_type_text"].values,
    });
  }

  const mesajeLabels = mesajeTextLabels.length > 0 ? true : false;

  const labelText = () => {
    if (mesajeTextLabels.length > 0) {
      return mesajeTextLabels.map((thisText, pos) => {
        if (thisText.link) {
          return (
            <div key={pos}>
              <a href={`${settings.baseUrl}/${thisText.link}/pag/`}>
                {thisText.text}
              </a>
            </div>
          );
        } else {
          return <div key={pos}>{thisText.text}</div>;
        }
      });
    }
    return null;
  };

  return (
    <>
      {mesajeLabels && (
        <div
          className="absolute top-0 right-0 px-2 text-center rounded-bl font-semibold text-xs bg-primary text-black"
          style={{ borderTopRightRadius: "3px" }}
        >
          {labelText()}
        </div>
      )}
    </>
  );
};

export default ProductLabels;
